module.exports = __webpack_public_path__ + "img/img_completed.f459864c.png";